/**
 * VendorPortalFlagService
 * Service for viewing vendor flags (read-only).
 * Route: api/vendor-portal/flags
 */
import { VendorPortalBaseService } from './VendorPortalBaseService';
/**
 * VendorPortalFlagService
 * Handles vendor flag viewing for the vendor portal (read-only).
 * Maps to /api/vendor-portal/flags endpoint
 */
export class VendorPortalFlagService extends VendorPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorPortalFlagService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? VendorPortalFlagService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all flags for the current vendor
     * GET /api/vendor-portal/flags
     */
    async getFlags() {
        const response = await this.getFlagsRaw();
        return response.data ?? [];
    }
    /**
     * Get all flags (raw response)
     */
    getFlagsRaw() {
        return this.get();
    }
    // ==================== GET BY ID ====================
    /**
     * Get a specific flag by ID
     * GET /api/vendor-portal/flags/{id}
     */
    async getFlag(id) {
        const response = await this.getFlagRaw(id);
        if (!response.data) {
            throw new Error(`Flag with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get a specific flag (raw response)
     */
    getFlagRaw(id) {
        return this.get(String(id));
    }
    // ==================== SUMMARY ====================
    /**
     * Get flag summary for the current vendor
     * GET /api/vendor-portal/flags/summary
     */
    async getSummary() {
        const response = await this.getSummaryRaw();
        if (!response.data) {
            throw new Error('Failed to retrieve flag summary');
        }
        return response.data;
    }
    /**
     * Get flag summary (raw response)
     */
    getSummaryRaw() {
        return this.get('summary');
    }
}
VendorPortalFlagService.DEFAULT_SERVICE_PATH = 'vendor-rating';
VendorPortalFlagService.BASE_PATH = 'api/vendor-portal/flags';
//# sourceMappingURL=VendorPortalFlagService.js.map